import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Judging process section for FAQ Page
 */
const JudgingProcessSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="judging-process-section-component"
    >
      <AccordionV2
        testId="judging-process"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="What is the judging process like? How long will it take?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            Each Award has its own screening/judging process. Refer to the
            individual Award for details:
          </p>

          <ul className="list-number list-outside pb-6 pl-8">
            <li>Best Managed Board;</li>
            <li>Best Chief Executive Officer;</li>
            <li>Best Chief Financial Officer;</li>
            <li>Best Risk Management;</li>
            <li>Best Investor Relations;</li>
            <li>Best Annual Report;</li>
            <li>Special Recognition;</li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default JudgingProcessSection;
